export default {
  // Tabs
  customModelsTab: 'Custom Models',
  adHocModelsTab: 'Ad-Hoc Models',
  automaticModelsTab: 'DIY Models',
  metadataTab: 'Metadata',
  channelTaxonomyTab: 'Channel Taxonomy',
  deletedModelsTab: 'Deleted Models',
  errorDeletingModel: 'Error deleting model',
  errorDeletingSomeModels: '{count} models could not be deleted',

  // Delete selected models dialog
  deleteSelectedTitle: 'Delete selected models?',
  deleteSelectedMessage: 'You are about to delete the following ({count}) models:',
  deleteSelectedConfirm: 'Are you sure?',
  deleteSelectedWarning: 'They can be recovered for 7 days by asking an administrator.',
  deleteSelectedInputLabel: "write 'delete' here to enable the Delete Models button",
  deleteModelsButton: 'Delete models',

  // Delete single model dialog
  warningTitle: 'Warning',
  deleteModelMessage: 'Deleting model: {name}',
  deleteModelConfirm: 'It can be recovered for 7 days by asking an administrator. Are you sure?',

  // Buttons
  createCustomModel: 'Create Custom Model',
  deleteSelectedModels: 'Delete selected models',
  cancel: 'Cancel',
  delete: 'Delete',
  close: 'Close',

  // Search
  search: 'Search',

  // Custom Models table headers
  headerName: 'Name',
  headerType: 'Type',
  headerCategory: 'Category',
  headerReference: 'Reference',
  headerMonthlySpend: 'Spend',
  headerMonthlySales: 'Sales',
  headerCountry: 'Country',
  headerQuality: 'Quality',
  headerModified: 'Modified',
  headerCreator: 'Creator',
  headerActions: 'Actions',

  // Edit name
  editLabel: 'Edit',
  inputTooLong: 'Input too long!',

  // Action tooltips
  recalculateModelReport: 'Recalculate Model Report',
  clone: 'Clone',
  deleteModel: 'Delete Model',
  printJsonToConsole: 'Print JSON to console',
  importPlans: 'Import Plans',
  modelSettings: 'Model Settings',
  modelData: 'Model Data',

  // Snackbar messages
  modelRenamed: 'Model renamed',
  errorRenamingModel: 'Error renaming model',
  idCopied: 'ID copied to clipboard!',

  // Model type labels (Metadata tab)
  typeCustomReference: 'Custom Ref.',
  typeCustomEkrm: 'Custom EKRM',
  typeAdHoc: 'Ad-Hoc',
  typeDiy: 'DIY',

  // Type column filter (Metadata tab)
  filterSelectAll: 'Select all',
  filterNone: '(none)',

  // Client-metadata columns (Metadata tab)
  metaHeaderClient: 'Client',
  metaHeaderBrand: 'Brand',
  metaHeaderCategory: 'Category',
  metaHeaderSubCategory: 'Sub-category',
  metaHeaderCountry: 'Country',

  // Channel Taxonomy tab
  taxonomyHeaderModel: 'Model',
  taxonomyHeaderChannel: 'Channel',
  taxonomyHeaderCode: 'Taxonomy',
  taxonomyExportCsv: 'Export CSV',
  taxonomyCodeCopied: 'Taxonomy code copied to clipboard!',

  // Ad-Hoc tab filters
  selectAllVisible: 'Select All Visible ({count})',
  allCountries: 'All countries',
  countriesSelected: '{count} of {total} countries selected',
  filterByCountry: 'Filter by Country',
  searchCountries: 'Search countries',
  allBrands: 'All brands',
  brandsSelected: '{count} of {total} brands selected',
  filterByBrand: 'Filter by Brand',
  searchBrands: 'Search brands',
  allClients: 'All clients',
  clientsSelected: '{count} of {total} clients selected',
  filterByClient: 'Filter by Client',
  searchClients: 'Search clients',
  allCategories: 'All categories',
  categoriesSelected: '{count} of {total} categories selected',
  filterByCategory: 'Filter by Category',
  searchCategories: 'Search categories',
  allSubcategories: 'All subcategories',
  subcategoriesSelected: '{count} of {total} subcategories selected',
  filterBySubcategory: 'Filter by Subcategory',
  searchSubcategories: 'Search subcategories',

  // Misc
  notAvailable: 'N/A',
  updating: '(Updating...)',
  // Versions
  current: 'current',
  versionDeployed: 'Deployed on {date}'
}
